export default function () {
  if (localStorage.getItem('current-locale') === 'pt') {
    return 'pt-BR';
  }
  return 'en-GB';
}
